module.exports = __webpack_public_path__ + "static/media/w40000.3ecce0f5.png";